<template>
	<div class="page full">
		<div id="public-web-container" class="hidden">
			<!-- <p class="">正在打开“功夫会”...</p>
      <a id="public-web-jump-button" href="javascript:" @click="openWeapp">
        <van-button :loading="loading" type="primary" loading-text="加载中..."
          >打开小程序</van-button
        >
      </a> -->
			<div class="tipLogo flex flex-justify">
				<img :src="logo" alt="">
			</div>
			<div class="jumpButton flex flex-justify">
				<a id="public-web-jump-button" href="javascript:" @click="openWeapp">
					<van-button class="junpBtn" :loading="loading" type="primary" loading-text="即将跳转功夫会...">跳转功夫会
					</van-button>
				</a>
			</div>
			<div class="tipProgram flex flex-justify">
				<img :src="Program" alt="">
			</div>
		</div>
		<div id="desktop-web-container" class="hidden">
			<p class="">请在手机打开网页链接</p>
		</div>
		<div class="tip_show flex flex-justify" v-if="errobj">
			<div class="tipText">
				<p>{{errmsg}}</p>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				loading: false,
				errobj: true,
				H5link: "",
				customLink: '',
				errmsg: "",
				twohouse: false,
				logo: require('../assets/logos.png'),
				Program: require('../assets/Programbg.png')
			};
		},
		created() {
			this.getLink();
		},
		mounted() {
			// 电脑or手机
			var ua = navigator.userAgent.toLowerCase();
			var isWXWork = ua.match(/wxwork/i) == "wxwork";
			var isWeixin = !isWXWork && ua.match(/micromessenger/i) == "micromessenger";
			var isMobile = false;
			var isDesktop = false;
			if (
				navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i
				)
			) {
				isMobile = true;
			} else {
				isDesktop = true;
			}
			if (isWeixin) {
				var containerEl = document.getElementById("wechat-web-container");
				containerEl.classList.remove("hidden");
				containerEl.classList.add("full", "wechat-web-container");

				var launchBtn = document.getElementById("launch-btn");
				// 监听
				launchBtn.addEventListener("ready", function(e) {
					console.log("开放标签 ready");
				});
				launchBtn.addEventListener("launch", function(e) {
					console.log("开放标签 success");
				});
				launchBtn.addEventListener("error", function(e) {
					console.log("开放标签 fail", e.detail);
				});
			} else if (isDesktop) {
				// 在 pc 上则给提示引导到手机端打开
				var containerEl = document.getElementById("desktop-web-container");
				containerEl.classList.remove("hidden");
				containerEl.classList.add("full", "desktop-web-container");
			} else {
				var containerEl = document.getElementById("public-web-container");
				containerEl.classList.remove("hidden");
				containerEl.classList.add("full", "public-web-container");

				var buttonEl = document.getElementById("public-web-jump-button");
				var buttonLoadingEl = document.getElementById(
					"public-web-jump-button-loading"
				);
			}
		},
		methods: {
			// 获取跳转链接
			getLink() {
				let query = this.$route.query.id;
				this.GFH_POST("messageJump", {
					id: query,
				})
				.then((res) => {
					if (res.data) {
						this.errmsg = '两秒后自动跳转小程序';
						this.H5link = res.data.openlink ? res.data.openlink : ''
						this.customLink = res.data.customLink ? res.data.customLink : ''
						this.twohouse = true;
						this.loading = true;
						if(this.customLink) {
							this.GFH_POST('generateUrlscheme', { path: this.customLink, query: res.data.activityParameter }).then(res => {
      						    location.href = res.data
      						})
							return
						}
						this.openWeapp();
					} else {
						this.errmsg = '链接已失效';
						let times = setTimeout(() => {
							clearTimeout(times);
							this.errobj = false;
							this.errmsg = '';
						}, 2000)
					}
					this.errobj = true;
				})
				.catch((err) => {
					this.errmsg = '链接已失效';
					let times1 = setTimeout(() => {
						clearTimeout(times1);
						this.errobj = false;
						this.errmsg = '';
					}, 2000);
					this.errobj = true;
				});
			},
			// 点击跳转
			async openWeapp() {
				if(this.twohouse){
					this.twohouse = false;
					let timesOpen = setTimeout(() => {
						clearTimeout(timesOpen);
						this.errobj = false;
						this.errmsg = '';
						this.loading = false;
						location.href = this.H5link;
					}, 2000)
					return;
				}
				if (this.H5link) {
					this.errobj = false;
					this.errmsg = '';
					this.loading = false;
					location.href = this.H5link;
				} else {
					this.errobj = true;
					this.errmsg = '链接已失效';
					let times2 = setTimeout(() => {
						clearTimeout(times2);
						this.errobj = false;
						this.errmsg = '';
						this.loading = false;
					}, 2000)

				}
				console.log(this.H5link);
			},
		},
	};
</script>

<style>
	.hidden {
		display: none;
	}

	.flex {
		display: -webkit-box;
		/* OLD - iOS 6-, Safari 3.1-6 */
		display: -moz-box;
		/* OLD - Firefox 19- (buggy but mostly works) */
		display: -ms-flexbox;
		/* TWEENER - IE 10 */
		display: -webkit-flex;
		/* NEW - Chrome */
		display: -moz-flex;
		display: -ms-flex;
		display: -o-flex;
		display: flex;
		/* NEW, Spec - Opera 12.1, Firefox 20+ */
	}

	.flex-center {
		-webkit-flex-direction: column;
		align-items: center;
		-webkit-align-items: center;
	}

	.flex-justify {
		justify-content: center;
		-webkit-justify-content: center;
		align-items: center;
		-webkit-align-items: center;
	}

	.full {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}

	.public-web-container {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.public-web-container p {
		position: absolute;
		top: 40%;
	}


	.public-web-container img {
		max-width: 100%;
	}

	.wechat-web-container {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.wechat-web-container p {
		position: absolute;
		top: 40%;
	}

	.wechat-web-container wx-open-launch-weapp {
		position: absolute;
		bottom: 40%;
		left: 0;
		right: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.desktop-web-container {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.desktop-web-container p {
		position: absolute;
		top: 40%;
	}

	.tip_show {
		width: 100%;
		height: auto;
		position: fixed;
		bottom: 22%;
		left: 0;
		display: flex;
		align-items: center;
	}

	.tipText {
		width: auto;
		height: auto;
		background-color: rgba(0, 0, 0, 0.5);
		color: #FFFFFF;
		padding: 5px 30px;
		border-radius: 5px;
	}

	.tipLogo {
		width: 100%;
		position: fixed;
		top: 20%;
		left: 0;
	}

	.jumpButton {
		width: 100%;
		position: fixed;
		top: 50%;
		left: 0;
	}

	#public-web-jump-button {
		width: 90%;
	}

	.junpBtn {
		width: 100%;
		background-color: #F8CD2B !important;
		border: 1px solid #F8CD2B !important;
		border-radius: 25px !important;
	}

	.tipProgram {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
	}
</style>
